module.exports = __webpack_public_path__ + "static/img/1.52f9d0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/1.png
// module id = QL0w
// module chunks = 0